import type { AnyObject, ObjectSchema } from 'yup';
import { ValidationError } from 'yup';

/**
 * Проверяет, является ли поле обязательным при заданных условиях (context).
 * @param schema Yup-схема
 * @param fieldName Имя поля
 * @param context Контекст (значения других полей, которые могут влиять на required)
 */
export const isFieldRequired = (
  schema: ObjectSchema<AnyObject>,
  fieldName: string,
  context: Record<string, unknown> = {},
): boolean => {
  try {
    // Пробуем провалидировать с undefined значением для поля
    schema.validateSyncAt(fieldName, { ...context, [fieldName]: undefined });
    return false; // Ошибки нет — поле не обязательное
  } catch (error) {
    if (error instanceof ValidationError) {
      // Считаем поле обязательным, если ошибка типа "required" или "optionality"
      return error.type === 'required' || error.type === 'optionality';
    }
    return false;
  }
};
